import React, { useState, useEffect } from "react";
import DisplayProfile from "./DisplayProfile";
import WebForm from "../pages/WebForm";
import appConfig, { getPortalKey } from "../config";
import { useLocation } from "react-router-dom";

// Helper to read StyleFolder from portal settings (same source as config.js)
const getStyleFolder = () => {
  try {
    const savedSettings = sessionStorage.getItem("portalSettings");
    if (savedSettings) {
      const settings = JSON.parse(savedSettings);
      if (settings?.StyleFolder) {
        return settings.StyleFolder.toLowerCase();
      }
    }
  } catch (e) {
    // Ignore and fall back to empty string
  }
  return "";
};

const HomeDropDown = () => {
  const [appName, setAppName] = useState("");
  const [styleFolder, setStyleFolder] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const optionFromUrl = searchParams.get("option");
  
  // Initialize parseData based on URL parameter
  const getInitialParseData = () => {
    if (optionFromUrl === "Change Contact Info") {
      return {
        iType: "ci",
        sType: "personnumbers",
        activeComponent: "",
      };
    }
    if (optionFromUrl === "Change Community Registration") {
      return {
        iType: "ci",
        sType: "comregistration",
        activeComponent: "",
      };
    }
    return {
      iType: "",
      sType: "",
      activeComponent: "",
    };
  };
  
  const [selectedOption, setSelectedOption] = useState(
    optionFromUrl || "Display Profile"
  );
  const [parseData, setParseData] = useState(getInitialParseData());

  // Initialize config, app name, and StyleFolder
  useEffect(() => {
    const key = getPortalKey();
    const config = appConfig[key] || appConfig.portal;
    if (config) {
      setAppName(config.name);
    }
    setStyleFolder(getStyleFolder());
  }, []);

  // Handle preselection from URL parameter (update when URL changes)
  useEffect(() => {
    if (optionFromUrl === "Change Contact Info") {
      setSelectedOption("Change Contact Info");
      setParseData({
        iType: "ci",
        sType: "personnumbers",
        activeComponent: "",
      });
    } else if (optionFromUrl === "Change Community Registration") {
      setSelectedOption("Change Community Registration");
      setParseData({
        iType: "ci",
        sType: "comregistration",
        activeComponent: "",
      });
    } else if (!optionFromUrl) {
      // Reset to Display Profile if no option in URL
      setSelectedOption("Display Profile");
      setParseData({
        iType: "",
        sType: "",
        activeComponent: "",
      });
    }
  }, [optionFromUrl]);

  useEffect(() => {
    if (appName === "TERO" && selectedOption === "Change Name") {
      setSelectedOption("Display Profile");
      setParseData({ iType: "", sType: "", activeComponent: "" });
    }
  }, [appName, selectedOption]);

  const handleOptionChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);

    if (selectedValue === "Change Address") {
      setParseData({
        iType: "ci",
        sType: "addresshist",
        activeComponent: "",
      });
    } else if (selectedValue === "Change Name") {
      setParseData({
        iType: "document",
        sType: "namechange",
        activeComponent: "",
      });
    } else if (selectedValue === "Change Contact Info") {
      setParseData({
        iType: "ci",
        sType: "personnumbers",
        activeComponent: "",
      });
    } else if (selectedValue === "Change Community Registration") {
      setParseData({
        iType: "clin",
        sType: "comregistration",
        activeComponent: "",
      });
    } else {
      setParseData({
        iType: "",
        sType: "",
        activeComponent: "",
      });
    }
  };
  const shouldHideChangeOptions =
    appName === "Prairie Band Potawatomi Nation" ||
    appName === "Colorado River Indian Tribes";
  const shouldHideChangeContactInfo = appName === "TERO";
  const shouldHideChangeName = appName === "TERO";
  return (
    <div className="w-full md:w-[80%] mx-auto mt-5 bg-white p-8 rounded-lg shadow-lg">
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 space-y-4 md:space-y-0">
        <h1 className="text-2xl font-bold">
          {selectedOption === "Display Profile" ? "My Profile" : selectedOption}
        </h1>

        <div className="flex items-center space-x-2 w-full md:w-auto">
          <span className="text-gray-600 whitespace-nowrap">I'd Like To:</span>
          <div className="relative w-full md:w-[200px]"> {/* Fixed width for select container */}
            <select
              className="border border-gray-300 rounded-lg px-4 py-2 appearance-none bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full truncate"
              value={selectedOption}
              onChange={handleOptionChange}
            >
              <option value="Display Profile">Display Profile</option>
              {/* <option value="Change Address">Change Address</option>
              <option value="Change Name">Change Name</option>
              <option value="Change Contact Info">Change Contact Info</option> */}

              {!shouldHideChangeOptions && (
                <>
                  <option value="Change Address">Change Address</option>
                  {!shouldHideChangeName && (
                    <option value="Change Name">Change Name</option>
                  )}
                  {!shouldHideChangeContactInfo && (
                    <option value="Change Contact Info">Change Contact Info</option>
                  )}
                  {styleFolder === "ccth" && (
                    <option value="Change Community Registration">
                      Change Community Registration
                    </option>
                  )}
                </>
              )}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg
                className="h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {selectedOption === "Display Profile" && <DisplayProfile />}
      {selectedOption === "Change Address" && <WebForm parseData={parseData} />}
      {selectedOption === "Change Name" && <WebForm parseData={parseData} />}
      {selectedOption === "Change Contact Info" && <WebForm parseData={parseData} />}
      {selectedOption === "Change Community Registration" && (
        <WebForm parseData={parseData} />
      )}
    </div>
  );
};

export default HomeDropDown;